import { fetchFilteredInventory } from "../../http/api";
import * as XLSX from 'xlsx';
import { getPreference } from "../../Utils/userPreferenceManger";

const getOrderedColumnsForDownload = (selectedColumns = [], sectionKey) => {
  if (!sectionKey || !Array.isArray(selectedColumns) || selectedColumns.length === 0) {
    return selectedColumns;
  }

  const savedOrder = getPreference(`columnOrder_${sectionKey}`);
  if (!Array.isArray(savedOrder) || savedOrder.length === 0) {
    return selectedColumns;
  }

  const selectedByKey = new Map(selectedColumns.map((column) => [column.key, column]));
  const orderedKeys = savedOrder
    .map((item) => (typeof item === "string" ? item : item?.key))
    .filter(Boolean);

  if (orderedKeys.length === 0) {
    return selectedColumns;
  }

  const orderedSelectedColumns = [];
  orderedKeys.forEach((key) => {
    const column = selectedByKey.get(key);
    if (column) {
      orderedSelectedColumns.push(column);
      selectedByKey.delete(key);
    }
  });

  selectedByKey.forEach((column) => orderedSelectedColumns.push(column));
  return orderedSelectedColumns;
};

export const downloadCSV = async (
  token,
  input,
  totalElements,
  selectedColumns,
  format = "xlsx",
  screenName = "inventory",
  options = {}
) => {
  try {
    const { sortConfig = null, sectionKey = null } = options;
    const payload = input ? { ...input, page: 0, size: totalElements } : { page: 0, size: totalElements };
    if (sortConfig?.columnToSort) {
      payload.columnToSort = sortConfig.columnToSort;
      payload.sortingDirection = sortConfig.sortingDirection || "asc";
    }

    const allData = await fetchFilteredInventory(token, payload);
    const effectiveColumns = getOrderedColumnsForDownload(selectedColumns, sectionKey);

    // Build a 2D array: first row = headers, following rows = values
    const headers = effectiveColumns.map((col) => col.name);
    const rows = allData.content.map((row) =>
      effectiveColumns.map((col) => {
        let value = row[col.key];
        if (value === null || value === undefined) return "";
        // Convert objects/arrays to JSON string
        if (typeof value === 'object') {
          try { return JSON.stringify(value); } catch (e) { return String(value); }
        }
        return value;
      })
    );

    const aoa = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inventory');

    let blob;
    let filename;
    if (format === "csv") {
      const csv = XLSX.utils.sheet_to_csv(ws);
      blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      filename = `${screenName}_data.csv`;
    } else {
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      filename = `${screenName}_data.xlsx`;
    }

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error fetching all data for XLSX:", error);
    alert("Failed to download all data. Please try again.");
  }
};